import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/layout/Layout';
import LoginPage from './pages/Loginpage/LoginPage';
import Dashboard from './pages/Dashboard';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import PatientList from './pages/PatientList';
import AddPatient from './pages/AddPatient';
import PatientProfile from './pages/PatientProfile';

import CapturePhoto from './pages/PhotoCapture';
import Gallery from './pages/Gallery';
import MultiPhotoCollage from './pages/MultiPhotoCollage';
import ClinicManagement from './pages/ClinicManagement';
import StaffManagement from './pages/StaffManagement';
import BeforeAfter from './pages/BeforeAfter';
import Privacypolicy from './components/Privacypolicy';

import SuperadminLogin from './pages/Loginpage/SuperadminLogin';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



function App() {


  return (
    <AuthProvider>
      <BrowserRouter basename="/admin">
        <Routes >


          <Route path="/superadmin" element={<SuperadminLogin />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/privacy-policy" element={<Privacypolicy />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="superadmin-dashboard" element={<SuperAdminDashboard />} />

            <Route path="patients" element={<PatientList />} />
            <Route path="patients/add" element={<AddPatient />} />
            <Route path="patients/:id" element={<PatientProfile />} />
            <Route path="gallery" element={<Gallery />} />
            <Route path="before-after" element={<BeforeAfter />} />
            <Route path="capture" element={<CapturePhoto />} />
            <Route path="collage" element={<MultiPhotoCollage />} />
            <Route path="clinics" element={<ClinicManagement />} />
            <Route path="staff" element={<StaffManagement />} />
            

            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <ToastContainer position="top-right" autoClose={3000} />
    </AuthProvider>
  );
}

export default App;
